export default __webpack_public_path__ + "static/media/Uphaar.6f4be82e.pdf";